import React, { ReactElement, useCallback, useMemo } from 'react';
import WealthieBreadCrumb from '../../components/BreadCrumb';
import Button from '../../components/Button';
import styles from './index.module.scss';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import WealthieTable from '../../components/WelthieTable';
import { getAllAdminApi } from '../../api';

const breadCrumbConfig = [
  {
    name: 'Wealthie',
  },
  {
    name: 'Admin users',
  },
];

function UserAdmin(): ReactElement {
  const history = useHistory();
  const adminColumn = useMemo(
    () => [
      {
        title: 'First Name',
        dataIndex: 'firstName',
        render: function renderFirstName(text: string, row: any) {
          return <Link to={`/user-admin/edit/${row.username}`}>{text}</Link>;
        },
      },
      {
        title: 'Last Name',
        dataIndex: 'lastName',
        render: function renderLastName(text: string, row: any) {
          return <Link to={`/user-admin/edit/${row.username}`}>{text}</Link>;
        },
      },
      {
        title: 'Email',
        dataIndex: 'email',
      },
      {
        title: 'Role',
        dataIndex: 'role',
      },
      {
        title: 'Updated date',
        dataIndex: 'updatedDate',
      },
    ],
    [],
  );
  const navigateToCreate = useCallback(
    () => history.push('/user-admin/create'),
    [history],
  );
  return (
    <>
      <WealthieBreadCrumb breadcrumbConfig={breadCrumbConfig} />
      <div className={styles.wrapper}>
        <WealthieTable
          isShowLoadingOnStart
          rowKey="username"
          columns={adminColumn}
          api={getAllAdminApi}
          extraApiParams={[]}
        />
        <Button
          onClick={navigateToCreate}
          className={styles.create_admin}
          type="primary"
        >
          Create Admin
        </Button>
      </div>
    </>
  );
}

export default UserAdmin;
